import ComputePipeline from "../../lib/services/compute/computepipeline";

export default class ClearBlobsPipeline extends ComputePipeline {
  private device: GPUDevice;
  private layout: GPUBindGroupLayout;

  constructor(key: string, shader: GPUShaderModule, device: GPUDevice, threads: number) {
    super(key,threads);
    this.device = device;
    
    this.layout = device.createBindGroupLayout({
      entries: [
        { binding: 0, visibility: GPUShaderStage.COMPUTE, buffer: { type: "storage" } },
      ],
    });

    this.pipeline = device.createComputePipeline({
      layout: device.createPipelineLayout({ bindGroupLayouts: [this.layout] }),
      compute: { module: shader, entryPoint: key },
    });
  }

  build(blob2_buffer: GPUBuffer): void {
    this.bindgroup = this.device.createBindGroup({
      layout: this.layout,
      entries: [
        { binding: 0, resource: { buffer: blob2_buffer } },
      ],
    });
  }
}